/* SHERRYS header wishlist drawer: uses the same product ID storage as the
   existing Khaadi collection hearts (skp-wishlist-v1). No app required. */
(() => {
  'use strict';
  if (window.__shwWishlistInstalled) return;
  window.__shwWishlistInstalled = true;

  const KEY = 'skp-wishlist-v1';
  const DATA_KEY = 'shw-wishlist-details-v1';
  let drawer = null;
  let trigger = null;
  let lastFocus = null;

  function getIds() {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value.map(String) : [];
    } catch { return []; }
  }
  function getDetails() {
    try { const value = JSON.parse(localStorage.getItem(DATA_KEY) || '{}'); return value && typeof value === 'object' ? value : {}; }
    catch { return {}; }
  }
  function storeDetails(obj) { try { localStorage.setItem(DATA_KEY, JSON.stringify(obj)); } catch {} }

  function extractDetails(card) {
    if (!card) return null;
    const json = card.querySelector('[data-skp-product-json]');
    let data = {};
    if (json) {
      try { data = JSON.parse(json.textContent); } catch {}
    }
    const url = String(data.url || card.querySelector('.skp-card__name a')?.getAttribute('href') || '');
    if (!url.startsWith('/')) return null;
    return {
      title: String(data.title || card.querySelector('.skp-card__name')?.textContent?.trim() || 'Saved product'),
      url,
      image: card.querySelector('.skp-card__slide img')?.currentSrc || card.querySelector('.skp-card__slide img')?.src || '',
      price: card.querySelector('.skp-card__prices strong')?.textContent?.trim() || ''
    };
  }
  function syncVisibleCards() {
    const ids = new Set(getIds());
    const data = getDetails();
    let changed = false;
    document.querySelectorAll('[data-skp-card][data-skp-product-id]').forEach(card => {
      const id = String(card.dataset.skpProductId);
      if (!ids.has(id)) return;
      const item = extractDetails(card);
      if (!item) return;
      data[id] = item;
      changed = true;
    });
    if (changed) storeDetails(data);
  }

  function element(tag, cssClass, text) {
    const node = document.createElement(tag);
    if (cssClass) node.className = cssClass;
    if (text != null) node.textContent = text;
    return node;
  }
  function buildDrawer() {
    if (drawer) return drawer;
    drawer = element('div', 'shw-wishlist-layer');
    drawer.hidden = true;
    drawer.innerHTML = `
      <div class="shw-wishlist-layer__veil" data-shw-wishlist-close></div>
      <section class="shw-wishlist-layer__panel" role="dialog" aria-modal="true" aria-labelledby="shw-wishlist-title" tabindex="-1">
        <div class="shw-wishlist-layer__top">
          <h2 class="shw-wishlist-layer__heading" id="shw-wishlist-title">MY WISHLIST</h2>
          <button class="shw-wishlist-layer__close" type="button" aria-label="Close wishlist" data-shw-wishlist-close>×</button>
        </div>
        <div class="shw-wishlist-layer__content" data-shw-wishlist-content></div>
      </section>`;
    document.body.append(drawer);
    drawer.addEventListener('click', e => {
      if (e.target.closest('[data-shw-wishlist-close]')) { close(); return; }
      const remove = e.target.closest('[data-shw-wishlist-remove]');
      if (remove) removeItem(remove.dataset.shwWishlistRemove);
    });
    return drawer;
  }

  function render() {
    if (!drawer) return;
    syncVisibleCards();
    const content = drawer.querySelector('[data-shw-wishlist-content]');
    content.replaceChildren();
    const ids = getIds();
    if (!ids.length) {
      const p = element('p', 'shw-wishlist-layer__empty', 'Your wishlist is empty. Tap the heart on a product to save it here.');
      content.append(p);
      return;
    }
    const data = getDetails();
    const list = element('ul', 'shw-wishlist-layer__list');
    ids.forEach(id => {
      const item = data[id];
      const li = element('li', 'shw-wishlist-layer__item');
      if (item && item.image) {
        const photo = element('img', 'shw-wishlist-layer__photo');
        photo.loading = 'lazy'; photo.src = item.image; photo.alt = item.title || 'Saved product';
        li.append(photo);
      } else {
        li.append(element('div','shw-wishlist-layer__photo'));
      }
      const info = element('div', 'shw-wishlist-layer__info');
      if (item && item.url && item.url.startsWith('/')) {
        const a = element('a', 'shw-wishlist-layer__title', item.title || 'Saved product');
        a.href = item.url;
        info.append(a);
      } else {
        info.append(element('div', 'shw-wishlist-layer__title', 'Saved product'));
        info.append(element('p', 'shw-wishlist-layer__unknown', 'Visit the collection to reload details for this older saved item.'));
      }
      if (item?.price) info.append(element('span', 'shw-wishlist-layer__price', item.price));
      li.append(info);
      const remove = element('button', 'shw-wishlist-layer__remove', 'Remove');
      remove.type = 'button'; remove.dataset.shwWishlistRemove = id;
      remove.setAttribute('aria-label', `Remove ${item?.title || 'saved product'} from wishlist`);
      li.append(remove);
      list.append(li);
    });
    content.append(list);
  }

  function removeItem(id) {
    const ids = getIds().filter(value => value !== String(id));
    try { localStorage.setItem(KEY, JSON.stringify(ids)); } catch {}
    const data = getDetails(); delete data[String(id)]; storeDetails(data);
    // Trigger the collection script's storage listener in the same window.
    try { window.dispatchEvent(new StorageEvent('storage', { key: KEY })); } catch {}
    render();
  }
  function open(button) {
    trigger = button; lastFocus = document.activeElement;
    buildDrawer(); render(); drawer.hidden = false;
    document.body.classList.add('shw-wishlist-open');
    button.setAttribute('aria-expanded', 'true');
    drawer.querySelector('.shw-wishlist-layer__close')?.focus({ preventScroll: true });
  }
  function close() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.classList.remove('shw-wishlist-open');
    trigger?.setAttribute('aria-expanded', 'false');
    if (lastFocus?.isConnected) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', e => {
    const button = e.target.closest('[data-shw-wishlist-open]');
    if (button) { e.preventDefault(); open(button); return; }
    // A product card heart uses delegated click in sherrys-khaadi-native.js.
    // Run after that handler to pick up the updated IDs.
    if (e.target.closest('[data-skp-wishlist]')) setTimeout(() => { syncVisibleCards(); if (drawer && !drawer.hidden) render(); }, 0);
  });
  document.addEventListener('keydown', e => {
    if (!drawer || drawer.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    if (e.key === 'Tab') {
      const buttons = Array.from(drawer.querySelectorAll('a[href], button:not([disabled])')).filter(el=>el.offsetParent !== null);
      if (!buttons.length) return;
      const first = buttons[0], last = buttons[buttons.length-1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('DOMContentLoaded', syncVisibleCards);
  window.addEventListener('storage', e=> { if (!e.key || e.key === KEY) { syncVisibleCards(); if (drawer && !drawer.hidden) render(); } });
})();
